export const ABCLogo = require('../assets/icons/applemessage.svg');
export const WhatsappLogo = require('../assets/icons/whatsapp.svg');
export const FacebookLogo = require('../assets/icons/facebook.svg');
export const ChatLogo = require('../assets/icons/webmessaging.svg');
export const SMSLogo = require('../assets/icons/sms.svg');
export const TwitterLogo = require('../assets/icons/twitter.svg');
export const SDKLogo = require('../assets/icons/mobilesdk.svg');
export const PegaLogo = require('../assets/icons/pega.svg');
export const CustomChannelLogo = require('../assets/icons/customchannel.svg');
export const CustomerSimulatorLogo = require('../assets/icons/customersimulator.svg');
export const GoogleTranslateLogo = require('../assets/icons/googletranslate.svg');
export const CombinedMessagingLogo = require('../assets/icons/CombinedMessagingChannelIcon.svg');
